import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
//import srImg from '../../images/services/service_image_8.webp' 
//import ConsultingService from '../../components/business-consulting-components/ConsultingService/ConsultingService';
//import ServiceSection from '../../components/software-company-components/ServiceSection/ServiceSection';
//import ServiceSection from '../../components/ServiceSection/ServiceSection';
//import WhyUs from '../AboutUsPage/WhyUs';
import Bg from '../../images/shapes/shape_title_under_line.svg'
import shape1 from '../../images/shapes/shape_line_5.svg'
import shape2 from '../../images/shapes/shape_line_6.svg'
import shape3 from '../../images/shapes/shape_space_1.svg'
import shape4 from '../../images/shapes/shape_angle_1.webp'
import shape5 from '../../images/shapes/shape_angle_2.webp'

import icon001 from '../../images/icons/icon_chart_4.svg'
import icon002 from '../../images/icons/icon_content_creation_2.svg'
import icon003 from '../../images/icons/icon_process_2.svg'
import icon004 from '../../images/icons/icon_analysis_2.svg'
import icon005 from '../../images/icons/icon_meeting_2.svg'

const ServicePage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Digital Marketing & Branding'} pagesub={'Services 😍'} pageTop={'Our'} />
                
				<section className="service_section pt-175 pb-80 bg-light section_decoration xb-hidden">
					<div className="container">
						<div className="heading_block text-center" style={{display: "none"}}>
							<div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
								Our Services
							</div>
							<h2 className="heading_text mb-0">
								How We Can <mark>Help</mark> You
							</h2>
						</div>

						<div className="row">
								
								<div className="col-lg-4">
									<div className="service_block_2">
										<div className="service_icon">
											<img src={icon001} alt="Lens & Lifestyle - Service icon" />
										</div>
										<h3 className="service_title">Social Media Marketing</h3>
										<ul className="icon_list unordered_list_block">											
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Instagram Management & Growth</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Content Planning & Strategy </span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Reels Creation & Trend Content</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Audience Engagement</span>
											</li>
										</ul>
									</div>
								</div>
								
								<div className="col-lg-4">
									<div className="service_block_2">
										<div className="service_icon">
											<img src={icon002} alt="Lens & Lifestyle - Service icon" />
										</div>
										<h3 className="service_title">Content Creation</h3>
										<ul className="icon_list unordered_list_block">											
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Ad Creatives</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Campaign Content</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Brand Storytelling </span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Caption & Copywriting</span>
											</li>											
										</ul>
									</div>
								</div>
								
								<div className="col-lg-4">
									<div className="service_block_2">
										<div className="service_icon">
											<img src={icon003} alt="Lens & Lifestyle - Service icon" />
										</div>
										<h3 className="service_title">Graphic Designing</h3>
										<ul className="icon_list unordered_list_block">											
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Social Media Posts</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Branding Creatives</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Marketing Materials</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Logo & Brand Identity</span>
											</li>
										</ul>
									</div>
								</div>
								
								<div className="col-lg-4">
									<div className="service_block_2">
										<div className="service_icon">
											<img src={icon004} alt="Lens & Lifestyle - Service icon" />
										</div>
										<h3 className="service_title">SEO</h3>
										<ul className="icon_list unordered_list_block">											
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Website SEO</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Keyword Strategy</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">On-page Optimization</span>
											</li>
										</ul>
									</div>
								</div>
								
								<div className="col-lg-4">
									<div className="service_block_2">
										<div className="service_icon">
											<img src={icon005} alt="Lens & Lifestyle - Service icon" />												
										</div>
										<h3 className="service_title">Podcast Production</h3>
										<ul className="icon_list unordered_list_block">											
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Setup & Recording</span>
											</li>
											<li>
												<span className="icon_list_icon"><i className="fa-regular fa-circle-dot"></i></span>
												<span className="icon_list_text">Editing & Distribution</span>
											</li>
										</ul>
									</div>
								</div>
								
								
						</div>
					</div>
					
					<div className="decoration_item shape_image_1" >
						<img src={shape1} alt="Lens & Lifestyle Shape"/>
					</div>
					<div className="decoration_item shape_image_2" >
						<img src={shape2} alt="Lens & Lifestyle Shape"/>
					</div>
					<div className="decoration_item shape_image_3" style={{display: "none"}}>
						<img src={shape3} alt="Lens & Lifestyle Shape"/>
					</div>
					<div className="decoration_item shape_image_4" style={{display: "none"}}>
						<img src={shape4} alt="Lens & Lifestyle Shape Angle"/>
					</div>
					<div className="decoration_item shape_image_5" style={{display: "none"}}>
						<img src={shape5} alt="Lens & Lifestyle Shape Angle"/>
					</div>			
				</section>
				
				{/* <ConsultingService /> */}
				
                {/* <ServiceSection /> */}
                {/*
				<div className="pt-130"></div>
                <WhyUs />
				*/}
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;
